import { Store } from '../core/store';
export const isSceneOutAnimationRunning = new Store(false);
export const isSceneInAnimationRunning = new Store(false);
export const isOutAnimationRunning = new Store(false);
export const isInAnimationRunning = new Store(false);
export const navigatorAppBarScrolledHeight = new Store(0);
export const navigatorAppBarExpandedHeight = new Store(0);
export const navigatorAppBarBaseHeight = new Store(0);
//# sourceMappingURL=stores.js.map